var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stripe-element tw-relative tw-rounded tw-bg-white tw-flex tw-flex-col tw-justify-center tw-px-2",class:{
    'stripe-element--has-icon': _vm.hasIcon,
    'stripe-element--focus': _vm.hasFocus,
    'stripe-element--complete': _vm.isComplete,
    'stripe-element--error': _vm.hasError,
    'stripe-element--disabled': _vm.disabled
  },on:{"click":_vm.focus}},[_c('label',{staticClass:"stripe-element__label",attrs:{"for":_vm.target},domProps:{"textContent":_vm._s(_vm.hasError ? _vm.errorMessage : _vm.label)}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }